export const REPIQ_SOCIAL_MEDIA_ANALYSIS_HISTORY = "REPIQ_SOCIAL_MEDIA_ANALYSIS_HISTORY";
export const SHOW_LOADER = "SHOW_REPIQ_SOCIAL_ANALYSIS_SERVICE_LOADER";

export interface ISocialMediaAnalysisHistoryState {
    socialMediaAnalysisHistory: ISocialMediaAnalysisHistory[];
    isLoading: boolean;
}

export interface ISocialMediaAnalysisHistory {
    networkName: string;
    networkID: number;
    month: string;
    category: string;
    result: number;
}

export interface getSocialMediaAnalysisHistory {
    type: "REPIQ_SOCIAL_MEDIA_ANALYSIS_HISTORY";
    socialMediaAnalysisHistory: ISocialMediaAnalysisHistory[];
}
export interface ShowAction {
    type: "SHOW_REPIQ_SOCIAL_ANALYSIS_SERVICE_LOADER";
    isLoading: boolean;
}

export type KnownAction = getSocialMediaAnalysisHistory | ShowAction;
